import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../actions/fillCombo_action';
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { getDRTDetails_action, updateDRT_action, getDRTSuggestions_action, updateDRTChecklist_action } from "../../../actions/admin_module_action/daily_routine_task_action/daily_routine_task_action";
import { exhibitionId, serviceTypeId, toastError, tasklistStatusActionId, contractorListActionId, toastSuccess, responsiblePersonListctionId, hallActionId, HallZoneActionId, HallZoneListActionId, vendorListId } from "../../../utils/constants";
import Select from 'react-select';
import Modal from "react-modal";
import { data } from "jquery";
// import 'bootstrap-icons/font/bootstrap-icons.css';
import DatePicker from "react-datepicker";
import moment from 'moment';
import zIndex from "@mui/material/styles/zIndex";
import AdminHeader from '../../../common_components/admin_module_header';
import { getDRCDetails_action, insertUpdateDRC_action } from "../../../actions/admin_module_action/daily_routine_checklist_action/daily_routine_checklist_action";
import { TimePicker } from "antd";
import dayjs from "dayjs";


class DailyRoutineTaskUpdate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            DailyRoutineChecklistHallID: '',
            DailyRoutineChecklistHdrID: '',
            proname: '',
            datestr: '',
            timestr: '',
            hallstr: '',
            checklistArr: [],
            statusList: [],
            DailyRoutineChecklistDateID: '',
            DailyRoutineChecklistScheduleTimeID: '',
            isView: false,
            DRCList: [],
            DRCListErr: '',
            vendorList: [],
            sugguestionsList: [],
            sugguestionsListErr: '',
            fromChecklist: false,
            loginAccesslist: [],
            openPicker: null,
            pendingTime: {},
        }
        this.getDRTDetails = this.getDRTDetails.bind(this)
        this.changeTable = this.changeTable.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.getDRTSuggestions = this.getDRTSuggestions.bind(this)
        this.getDRCDetails = this.getDRCDetails.bind(this)
        this.insertUpdateDRT = this.insertUpdateDRT.bind(this)
        this.addMainTask = this.addMainTask.bind(this)
        this.addSubTask = this.addSubTask.bind(this)
        this.editChecklist = this.editChecklist.bind(this)
        this.checkTime = this.checkTime.bind(this)
        this.onDeleteChecklist = this.onDeleteChecklist.bind(this)
        this.onChecktSuggestions = this.onChecktSuggestions.bind(this)
        this.insertUpdateDRC = this.insertUpdateDRC.bind(this)
    }

    // The record to open. Embedded (e.g. the organizer layout view's modal) it
    // comes in as the routineState prop - same shape as the route state the
    // task list navigates with.
    routeState() {
        return this.props.embedded ? this.props.routineState : this.props.location.state
    }

    // After Save / on Back: embedded, hand back to the host instead of navigating.
    leavePage(saved) {
        const { fromChecklist } = this.state
        if (this.props.embedded) {
            if (this.props.onDone) this.props.onDone(saved)
            return
        }
        if (!saved) {
            fromChecklist ? this.props.navigate('/dailyRoutineChecklistList', { state: { fromUpdate: true } }) : this.props.navigate(-1, { state: { fromUpdate: true } })
            return
        }
        fromChecklist ? this.props.navigate('/dailyRoutineChecklistList', { state: { fromUpdate: true } }) : this.props.navigate('/dailyRoutineTaskList', { state: { fromUpdate: true } })
    }

    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        // this.getFillList(HallListActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
        this.getFillList(tasklistStatusActionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
            // this.getFillList(responsiblePersonListctionId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {
            const routeState = this.routeState()
            if (routeState != null && routeState.DailyRoutineChecklistHdrID != null && routeState.DailyRoutineChecklistHdrID != undefined && routeState.DailyRoutineChecklistHallID != null && routeState.DailyRoutineChecklistHallID != undefined) {
                this.setState({
                    DailyRoutineChecklistHdrID: routeState.DailyRoutineChecklistHdrID,
                    DailyRoutineChecklistHallID: routeState.DailyRoutineChecklistHallID,
                    DailyRoutineChecklistDateID: routeState.DailyRoutineChecklistDateID,
                    DailyRoutineChecklistScheduleTimeID: routeState.DailyRoutineChecklistScheduleTimeID,
                    proname: routeState.name,
                    datestr: routeState.datestr,
                    timestr: routeState.timestr,
                    hallstr: routeState.hallstr,
                    isView: routeState.isView,
                    fromChecklist: routeState.fromChecklist
                })
                setTimeout(() => {
                    this.getFillList(vendorListId, sessionStorage.getItem("sessionExhibitionID"), '', '', '', '').then(() => {

                        this.getDRTDetails(routeState.DailyRoutineChecklistHdrID, routeState.DailyRoutineChecklistHallID, routeState.DailyRoutineChecklistDateID, routeState.DailyRoutineChecklistScheduleTimeID)
                        this.getDRTSuggestions(routeState.DailyRoutineChecklistHdrID, routeState.DailyRoutineChecklistHallID, routeState.DailyRoutineChecklistDateID, routeState.DailyRoutineChecklistScheduleTimeID)
                        this.getDRCDetails(routeState.DailyRoutineChecklistHdrID)
                    })
                }, 200);

            }
            // })
        })
        // })
    }


    getDRTDetails(id1, id2, id3, id4) {
        const { isLoading, title, DRCList, fromDate, statusList, toDate, scheduleTimeList, checklistArr, hallList, DailyRoutineChecklistHdrID, Area, Rperson, AreaList, RpList } = this.state
        this.setState({ isLoading: true })
        this.props.getDRTDetails_action(id1, id2, id3, id4)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data[0].length > 0) {
                        data.data[0].map(item => {
                            var statusid = 1
                            console.log(statusList)
                            statusList.map(item2 => {
                                if (item2.Name == item.Status) {
                                    statusid = item2.HallCheckliststatusID
                                }
                            })
                            item.HallCheckliststatusID = statusid
                            //     item.isSelect = false
                            //     item.DailyRoutineChecklistHallID = ''
                            //     item.UserID = ''
                        })
                        this.setState({
                            checklistArr: data.data[0],
                            // VendorDetailsNo: data.data[0][0].VendorMobileNo,
                        })

                    }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    getDRTSuggestions(id1, id2, id3, id4) {
        const { isLoading, title, DRCList, fromDate, statusList, toDate, scheduleTimeList, checklistArr, hallList, DailyRoutineChecklistHdrID, Area, Rperson, AreaList, RpList } = this.state
        this.setState({ isLoading: true })
        this.props.getDRTSuggestions_action(id1, id2, id3, id4)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data[0].length > 0) {

                        // data.data[0].map(item => {
                        //     var statusid = 1
                        //     console.log(statusList)
                        //     statusList.map(item2 => {
                        //         if (item2.Name == item.Status) {
                        //             statusid = item2.HallCheckliststatusID
                        //         }
                        //     })
                        //     item.HallCheckliststatusID = statusid
                        // })
                        // this.setState({
                        //     checklistArr: data.data[0],
                        // })
                        // var tempCheckList = []
                        // if (data.data[0].length > 0) {
                        //     for (var i = 0; i < data.data[0].length; i++) {
                        //         var obj = { srno: data.data[0][i].SrNo, parentId: data.data[0][i].ParentChecklist, parentSrno: data.data[0][i].ParentSrno, desc: data.data[0][i].ChecklistDescription, addInt: data.data[0][i].AdditionalInstruction, startTime: data.data[0][i].StartTime, endTime: data.data[0][i].EndTime, AccountID: data.data[0][i].ChecklistAssignID, DailyRoutineChecklistDetailID: data.data[0][i].DailyRoutineChecklistDetailID, ChecklistStatusID: '' }
                        //         tempCheckList.push(obj)
                        //     }
                        //     this.setState({ DRCList: tempCheckList })
                        // }
                        data.data[0].length > 0 && data.data[0].map((item, i) => {
                            item.isSelect = false
                            item.tempId = i + 1
                        })
                        this.setState({
                            sugguestionsList: data.data[0]
                        })
                    }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID) {
        const { } = this.state
        return new Promise((resolve, reject) => {

            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, exhRegistrationID)
                .then((data) => {
                    if (data.error != 1) {
                        // voucher list
                        if (actionID === vendorListId) {
                            this.setState({ vendorList: data.data })
                            resolve()

                        }
                        if (actionID === tasklistStatusActionId) {
                            // data.data.map(item => {
                            //     item.isSelect = false
                            //     item.DailyRoutineChecklistHallID = ''
                            //     item.UserID = ''
                            // })
                            this.setState({ statusList: data.data })
                            resolve()

                        }
                    }
                })
        })
    }

    getDRCDetails(id) {
        const { isLoading, title, DRCList, fromDate, toDate, scheduleTimeList, hallList, DailyRoutineChecklistHdrID, Area, Rperson, AreaList, RpList } = this.state
        this.setState({ isLoading: true })
        this.props.getDRCDetails_action(id)
            .then((data) => {
                if (data.error != 1) {
                    // if (data.data[0].length > 0) {
                    //     var toggle = data.data[0][0].isHallManager ? 1 : 2
                    //     this.setState({
                    //         title: data.data[0][0].ProgramTitle,
                    //         fromDate: data.data[0][0].FromDate != '' ? new Date(data.data[0][0].FromDate) : '',
                    //         preAlertTime: data.data[0][0].PreAlertTime,
                    //         toDate: data.data[0][0].ToDate != '' ? new Date(data.data[0][0].ToDate) : '',
                    //         rPersonToggle: data.data[0][0].isHallManager ? 1 : 2,
                    //         // VendorDetailsNo: data.data[0][0].VendorMobileNo, moment(toDate).format('YYYY-MM-DD')
                    //     })
                    // }
                    // setTimeout(() => {
                    //     console.log(new Date(data.data[0][0].FromDate))
                    // }, 500);
                    // if (data.data[1].length > 0) {
                    //     for (var i = 0; i < data.data[1].length; i++) {
                    //         scheduleTimeList.push({ scheduleStartTime: data.data[1][i].FromTime, scheduleEndTime: data.data[1][i].ToTime, DailyRoutineChecklistScheduleTimeID: data.data[1][i].DailyRoutineChecklistScheduleTimeID })
                    //     }
                    //     this.setState({
                    //         scheduleTimeList: scheduleTimeList,
                    //     })
                    // }
                    // if (data.data[2].length > 0) {
                    //     var accid = ''
                    //     for (var i = 0; i < data.data[2].length; i++) {
                    //         hallList.map(item => {
                    //             if (data.data[2][i].HallID == item.HallId) {
                    //                 item.isSelect = true
                    //                 item.DailyRoutineChecklistHallID = data.data[2][i].DailyRoutineChecklistHallID
                    //                 accid = data.data[2][i].UserID
                    //             }
                    //         })
                    //     }
                    //     if (toggle == 2) {
                    //         // RpList.map(item => {
                    //         //     if (item.AccountID == accid) {
                    //         //         item.isSelect = true
                    //         //     }
                    //         // })
                    //         this.setState({ rPersonID: accid })
                    //     }
                    //     this.setState({
                    //         hallList: hallList
                    //     })
                    // }
                    var tempCheckList = []
                    if (data.data[3].length > 0) {
                        for (var i = 0; i < data.data[3].length; i++) {
                            var obj = { srno: data.data[3][i].SrNo, parentId: data.data[3][i].ParentChecklist, parentSrno: data.data[3][i].ParentSrno, desc: data.data[3][i].ChecklistDescription, addInt: data.data[3][i].AdditionalInstruction, startTime: data.data[3][i].StartTime, endTime: data.data[3][i].EndTime, AccountID: data.data[3][i].ChecklistAssignID, DailyRoutineChecklistDetailID: data.data[3][i].DailyRoutineChecklistDetailID, ChecklistStatusID: '' }
                            tempCheckList.push(obj)
                        }
                        this.setState({ DRCList: tempCheckList })
                    }
                    this.setState({ isLoading: false })
                } else {
                    toastError('Something went wrong...')
                    this.setState({ isLoading: false })

                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    changeTable(mode, id, value) {
        console.log(value)
        const { isLoading, isOpen, title, currentPage, DRTList, fromDate, checklistArr, toDate, Area, Rperson, AreaList, RpList, proname, datestr, timestr, hallstr } = this.state
        for (var i = 0; i < checklistArr.length; i++) {
            if (checklistArr[i].DailyRoutineHallChecklistMappingID == id) {
                if (mode == 0) {
                    checklistArr[i].HallCheckliststatusID = value
                } else if (mode == 1) {
                    checklistArr[i].Remark = value
                }
            }
        }
        this.setState({ checklistArr: checklistArr })

    }
    insertUpdateDRT() {
        const { isLoading, fromChecklist, specificPersonList, DailyRoutineChecklistHdrID, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, checklistArr, rPersonID, DRCList, proname, hallstr } = this.state
        var Err = false
        console.log(checklistArr)
        checklistArr.map(item => {
            if (item.HallCheckliststatusID == null) {
                item.HallCheckliststatusID = 1
            }
        })
        this.setState({ isLoading: true })
        var dateTime = moment(new Date()).format('DD/MM/YYYY, HH:mm')
        this.props.updateDRT_action(checklistArr, proname, hallstr, dateTime, sessionStorage.getItem("firstNameSS"))
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Updated successfully")
                    setTimeout(() => {
                        this.leavePage(true)
                    }, 1000);
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateDRC() {
        const { isLoading, specificPersonList, fromChecklist, DailyRoutineChecklistHdrID, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, sugguestionsList, rPersonID, DRCList } = this.state
        var Err = false
        for (var i = 0; i < DRCList.length; i++) {
            if (DRCList[i].desc == '') {
                this.setState({ DRCListErr: 'Please Enter Description' })
                Err = true
            }
            if (DRCList[i].startTime == '') {
                this.setState({ DRCListErr: 'Please Enter Start Time' })
                Err = true
            }
            if (DRCList[i].endTime == '') {
                this.setState({ DRCListErr: 'Please Enter End Time' })
                Err = true
            }
            if (DRCList[i].AccountID == '') {
                this.setState({ DRCListErr: 'Please Select Service Partner' })
                Err = true
            }
        }
        var isAllUncheck = sugguestionsList.every(item => item.isSelect == false)
        if (isAllUncheck) {
            Err = true
            toastError('Please Select Select atleast 1 sugguestion')
            return
        }
        setTimeout(() => {
            if (!Err) {
                var tempSuggestion = []
                sugguestionsList.forEach(item => {
                    if (item.isSelect) {
                        tempSuggestion.push(item)
                    }
                })
                var finalList = []
                for (var i = 0; i < tempSuggestion.length; i++) {
                    for (var j = 0; j < DRCList.length; j++) {
                        var obj = {
                            srno: DRCList[j].srno,
                            desc: DRCList[j].desc,
                            addInt: DRCList[j].addInt,
                            AccountID: DRCList[j].AccountID,
                            parentId: DRCList[j].parentId,
                            ChecklistStatusID: '',
                            startTime: DRCList[j].startTime,
                            endTime: DRCList[j].endTime,
                            Remark: DRCList[j].Remark ?? '',
                            parentSrno: DRCList[j].parentSrno,
                            DailyRoutineChecklistDateID: tempSuggestion[i].DailyRoutineChecklistDateID,
                            DailyRoutineChecklistHallID: tempSuggestion[i].DailyRoutineChecklistHallID,
                            DailyRoutineChecklistScheduleTimeID: tempSuggestion[i].DailyRoutineChecklistScheduleTimeID,
                        }
                        finalList.push(obj)
                    }
                }
                // scheduleTimeList.map(item => {
                // })
                console.log(DRCList, finalList)
                this.setState({ isLoading: true })
                this.props.updateDRTChecklist_action(DailyRoutineChecklistHdrID != '' && DailyRoutineChecklistHdrID != null ? DailyRoutineChecklistHdrID : null, finalList)
                    .then((data) => {
                        if (data.error != 1) {
                            // if (data.data.length > 0) {
                            // if (data.data[0].length > 0) {
                            // this.setState({ DDreturnListArr: data.data, })
                            // }
                            // }
                            toastSuccess("Updated successfully")
                            setTimeout(() => {
                                this.leavePage(true)

                            }, 1000);
                            // this.setState({ isLoading: false })
                        } else {
                            toastError(data.msg)
                            this.setState({ isLoading: false })
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Enter mandatory fields")
            }
        }, 200);
    }

    addMainTask() {
        const { isLoading, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        var newSr = 0
        DRCList.map(item => {
            if (item.parentId == null) {
                newSr = newSr + 1
            }
        })
        DRCList.push({ srno: newSr + 1, parentId: null, desc: '', parentSrno: null, addInt: '', startTime: '', endTime: '', DailyRoutineChecklistDetailID: '', AccountID: '', ChecklistStatusID: '' })
        this.setState({ DRCList: DRCList })
    }

    addSubTask(id) {
        const { isLoading, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        var parInd = 0
        var parId = 0
        DRCList.map((item, i) => {
            if (item.srno == id) {
                parInd = i
                parId = item.DailyRoutineChecklistDetailID
            }
        })
        var totalSub = 0
        DRCList.map((item, i) => {
            if (item.parentSrno != null) {
                if (id == item.parentSrno) {
                    totalSub = totalSub + 1
                }
            }
        })
        DRCList.splice(parInd + totalSub + 1, 0, { srno: `${id}.${totalSub + 1}`, DailyRoutineChecklistDetailID: '', parentId: parId, desc: '', addInt: '', startTime: '', endTime: '', AccountID: '', ChecklistStatusID: '', parentSrno: id, })
        this.setState({ DRCList: DRCList })
    }

    editChecklist(value, id, mode) {
        const { isLoading, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        if (mode == 0) {
            DRCList[id].desc = value
        } else if (mode == 1) {
            DRCList[id].addInt = value
        } else if (mode == 2) {
            DRCList[id].startTime = value
        } else if (mode == 3) {
            DRCList[id].endTime = value
        } else if (mode == 4) {
            DRCList[id].AccountID = value
        }
        console.log(DRCList[id])
        this.setState({ DRCList: DRCList, DRCListErr: '' })
    }

    onTimePickerSelect = (time, fieldKey, rowIndex, mode) => {
        if (!time) return;
        const { pendingTime } = this.state;
        const prevPending = pendingTime[fieldKey];
        const newHour = time.hour();
        const newMinute = time.minute();

        const hourChanged = !prevPending || prevPending.hour !== newHour;
        const minuteChanged = prevPending && prevPending.minute !== newMinute;

        this.setState({
            pendingTime: {
                ...pendingTime,
                [fieldKey]: { hour: newHour, minute: newMinute }
            }
        });

        // Always update the row immediately so the selected hour/minute is reflected in the input
        const timeStr = time.format("HH:mm");
        this.editChecklist(timeStr, rowIndex, mode);

        if (hourChanged) {
            // Scroll selected hour into view, and focus/scroll minute column
            setTimeout(() => {
                const hourSelected = document.querySelector(".ant-picker-time-panel-column:nth-child(1) .ant-picker-time-panel-cell-selected");
                if (hourSelected) {
                    hourSelected.scrollIntoView?.({ behavior: "smooth", block: "center" });
                }
                const minuteColumn = document.querySelector(".ant-picker-time-panel-column:nth-child(2)");
                if (minuteColumn) {
                    minuteColumn.focus();
                }
                const minuteSelected = document.querySelector(".ant-picker-time-panel-column:nth-child(2) .ant-picker-time-panel-cell-selected");
                if (minuteSelected) {
                    minuteSelected.scrollIntoView?.({ behavior: "smooth", block: "center" });
                }
            }, 50);
        }

        // When user selects minute, automatically close popup and run validation check
        if (minuteChanged) {
            const minuteSelected = document.querySelector(".ant-picker-time-panel-column:nth-child(2) .ant-picker-time-panel-cell-selected");
            if (minuteSelected) {
                minuteSelected.scrollIntoView?.({ behavior: "smooth", block: "center" });
            }
            this.setState({ openPicker: null });
            setTimeout(() => {
                this.checkTime(mode === 2 ? 1 : 2, 1);
            }, 100);
        }
    };

    onTimePickerChange = (time, timeString, rowIndex, mode, fieldKey) => {
        const val = time ? time.format("HH:mm") : (timeString || '');
        this.editChecklist(val, rowIndex, mode);
        this.setState({ openPicker: null });
        if (val) {
            setTimeout(() => {
                this.checkTime(mode === 2 ? 1 : 2, 1);
            }, 100);
        }
    };

    checkTime(mode, flag) {
        const { isLoading, vendorList, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList, titleErr, datestr, fromDateErr, toDateErr, preAlertTimeErr, scheduleTimeListErr, hallListErr, rPersonIDErr, DRCListErr, } = this.state
        var err = false
        const today = new Date();
        return new Promise((resolve, reject) => {
            if (datestr && datestr != '') {
                const parsedDate = moment(datestr, ['DD/MM/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY']).toDate();
                if (parsedDate && !isNaN(parsedDate.getTime()) &&
                    parsedDate.getDate() === today.getDate() &&
                    parsedDate.getMonth() === today.getMonth() &&
                    parsedDate.getFullYear() === today.getFullYear()
                ) {
                    if (flag == 1) {
                        for (var i = 0; i < DRCList.length; i++) {
                            if (DRCList[i].startTime != '') {
                                const [h, m] = DRCList[i].startTime.split(":").map(Number);
                                const now = new Date();
                                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                                const selectedMinutes = h * 60 + m;
                                if (selectedMinutes < currentMinutes) {
                                    DRCList[i].startTime = ''
                                    this.setState({ DRCList: DRCList })
                                    toastError('Start time cannot be before current time')
                                    err = true
                                    return
                                }
                            }
                            if (DRCList[i].endTime != '') {
                                const [h, m] = DRCList[i].endTime.split(":").map(Number);
                                const now = new Date();
                                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                                const selectedMinutes = h * 60 + m;
                                if (selectedMinutes < currentMinutes) {
                                    DRCList[i].endTime = ''
                                    this.setState({ DRCList: DRCList })
                                    toastError('End time cannot be before current time')
                                    err = true
                                    return
                                }
                            }
                        }
                    }
                }
            }
            if (flag == 1) {
                for (var i = 0; i < DRCList.length; i++) {
                    if (DRCList[i].startTime != '' && DRCList[i].endTime != '') {
                        if (DRCList[i].startTime > DRCList[i].endTime) {
                            if (mode == 1) {
                                DRCList[i].startTime = ''
                                this.setState({ DRCList: DRCList })
                                toastError('Start time cannot be more than End time')
                            } else if (mode == 2) {
                                DRCList[i].endTime = ''
                                this.setState({ DRCList: DRCList })
                                toastError('End time cannot be less than Start time')
                            }
                        }
                    }
                }
            }


            setTimeout(() => {

                resolve(err)
            }, 200);
        })
    }

    onDeleteChecklist(id, mode) {
        const { isLoading, specificPersonList, hallList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        if (mode == 1) {
            DRCList.splice(id, 1)
        } else {
            var parid = ''
            DRCList.map((item, i) => {
                if (id == i) {
                    parid = item.id
                }
            })
            var totalSub = 0
            DRCList.map((item, i) => {
                if (item.parentId != null) {
                    if (parid == item.parentId) {
                        totalSub = totalSub + 1
                    }
                }
            })
            DRCList.splice(id, totalSub + 1)
        }
        var newSr = 0
        var subcount = 0
        DRCList.map((item, i) => {
            if (item.parentId == null) {
                item.id = newSr + 1
                item.srno = newSr + 1
                newSr = newSr + 1
                subcount = 0
            } else {
                item.id = `${newSr}.${subcount + 1}`
                item.srno = `${newSr}.${subcount + 1}`
                subcount = subcount + 1
            }
        })
        this.setState({ DRCList: DRCList })
    }

    onChecktSuggestions(id) {
        const { isLoading, hallList, sugguestionsList, isOpen, title, fromDate, toDate, preAlertTime, scheduleStartTime, scheduleEndTime, scheduleTimeList, areaSelect, rPersonToggle, rPersonID, DRCList } = this.state
        sugguestionsList.map(item => {
            if (item.tempId == id) {
                if (item.isSelect == true) {
                    item.isSelect = false
                } else {
                    item.isSelect = true
                }
            }
        })
        this.setState({ sugguestionsList: sugguestionsList, sugguestionsListErr: '', })
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '77');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        // Hall Manager Team Member (RoleID 20) does work updation on routine tasks
        // but doesn't carry module 77 in their access list, so grant update explicitly.
        if (sessionStorage.getItem('RoleIDSS') == 20) {
            return true;
        }
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '77');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '77');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    getViewAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '77');
        if (moduleAccess) {
            return moduleAccess.ReadAccess;
        } else {
            return false
        }
        return false;
    }

    truncateText(text) {
        return text.length > 100 ? text.slice(0, 100) + "..." : text;
    }

    render() {
        const { isLoading, DRCListErr, isOpen, isView, title, currentPage, DRTList, fromDate, statusList, checklistArr, schecklistArr, toDate, Area, Rperson, AreaList, RpList, proname, datestr, fromChecklist, sugguestionsListErr, sugguestionsList, vendorList, timestr, hallstr, DRCList } = this.state
        console.log(checklistArr)
        var totalParents = 0
        for (var i = 0; i < DRCList.length; i++) {
            if (DRCList[i].parentId == null) {

                totalParents = totalParents + 1
            }
        }
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                {/* Embedded in a host's modal: the host owns the toasts and the page chrome. */}
                {!this.props.embedded && <ToastContainer />}
                {!this.props.embedded && (sessionStorage.getItem("RoleIDSS") != 16 && sessionStorage.getItem("RoleIDSS") != 7 && sessionStorage.getItem("RoleIDSS") != 17 && sessionStorage.getItem("RoleIDSS") != 25 && sessionStorage.getItem("RoleIDSS") != 20 ? <HeaderWithLogo /> : <AdminHeader />)}
                {/* <HeaderWithLogo /> */}
                <>
                    {!this.props.embedded && sessionStorage.getItem("RoleIDSS") != 16 && sessionStorage.getItem("RoleIDSS") != 7 && sessionStorage.getItem("RoleIDSS") != 17 && sessionStorage.getItem("RoleIDSS") != 25 && sessionStorage.getItem("RoleIDSS") != 20 && <AdminDrawer />}
                    {/* <div className="app-content with-dr-container com-height"> */}

                    <div style={{ marginTop: '5rem !important' }} className={!this.props.embedded && sessionStorage.getItem("RoleIDSS") != 7 && sessionStorage.getItem("RoleIDSS") != 17 && sessionStorage.getItem("RoleIDSS") != 16 & sessionStorage.getItem("RoleIDSS") != 25 && sessionStorage.getItem("RoleIDSS") != 20 ? "with-dr-container" : " "}>
                        <main>
                            <div class="row m-0">
                                {/* Title strip edge to edge (the page padding sits on the section below, not here) */}
                                {/* p-0: as a .row child it picked up Bootstrap's 12px column padding on top of the title's px-3, so the title sat further in than the content */}
                                {!this.props.embedded && <div class="breadcrumb-scroll-fixed p-0">
                                    <h6 class="mb-0 py-2 px-3 text-white">{sessionStorage.getItem("RoleIDSS") == 16 || sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17 || sessionStorage.getItem("RoleIDSS") == 25 || sessionStorage.getItem("RoleIDSS") == 20 ? '' : 'Organizer '}
                                        Daily Routine Task</h6>
                                </div>}

                                {/* px-3: the same 16px on both sides as the other admin pages (embedded: the host page sets it) */}
                                <section className={this.props.embedded ? "" : "admin-top-space px-3"} style={{ marginTop: this.props.embedded ? 0 : '8rem' }}>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="">
                                                <div class="">
                                                    <h6 class="fw-semibold mb-0 mt-2">Checklist Section</h6>

                                                    <div className="my-3 mb-2">
                                                        <div className="d-flex flex-wrap align-items-center border rounded-3 p-3 bg-white shadow-none">
                                                            <div className="w-100 text-left mb-1 fw-semibold" style={{ fontSize: "large" }}>
                                                                {proname}
                                                            </div>
                                                            <div className="me-4">
                                                                <i className="bi bi-calendar-event me-1 grid-icon"></i>{datestr}
                                                            </div>
                                                            <div className="me-4">
                                                                <i className="bi bi-clock me-1 grid-icon"></i>{timestr}
                                                            </div>
                                                            <div>
                                                                <i className="bi bi-geo-alt me-1 grid-icon"></i>{hallstr}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row m-0">

                                                        {(!isView && !fromChecklist) && <div class="table-responsive sticky-table-wrapper p-0" style={{ maxHeight: "calc(100vh - 320px)", overflowY: "auto" }}>
                                                            <table class="table table-hover table-striped sticky-table border mb-0 p-0">
                                                                {/* zIndex above the body cells (custom.css gives .sticky-table td z-index 1), so rows scroll under the header */}
                                                                <thead class="table-light" style={{ position: "sticky", top: 0, zIndex: 21 }}>
                                                                    <tr>
                                                                        <th style={{ width: '50px' }} class="text-center">Sr No.</th>
                                                                        <th>Checklist Description</th>
                                                                        <th>Service Partner</th>
                                                                        <th style={{ minWidth: '150px' }} class="text-center">Start-End Time</th>
                                                                        <th style={{ minWidth: '135px' }}>Status</th>
                                                                        <th style={{ minWidth: '300px' }}>Remark</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {checklistArr.length > 0 && checklistArr.map(item => (
                                                                        <tr>
                                                                            <td>{item.SrNo}</td>
                                                                            <td>
                                                                                <span title={item.ChecklistDescription}>
                                                                                    {item.ChecklistDescription.length > 100 ? this.truncateText(item.ChecklistDescription) : item.ChecklistDescription}
                                                                                </span>
                                                                                {/* {item.Remark != null && item.Remark != '' && <i class="bi bi-info-circle text-primary" data-bs-toggle="tooltip" data-bs-placement="top" aria-label={item.Remark} data-bs-original-title={item.Remark} ></i>} */}
                                                                            </td>
                                                                            <td>
                                                                                {item.CompanyName}
                                                                                {/* {item.Remark != null && item.Remark != '' && <i class="bi bi-info-circle text-primary" data-bs-toggle="tooltip" data-bs-placement="top" aria-label={item.Remark} data-bs-original-title={item.Remark} ></i>} */}
                                                                            </td>
                                                                            <td class="text-center">{item.EndTime != '' && item.EndTime != null ? `${item.StartTime} to ${item.EndTime}` : item.StartTime} </td>
                                                                            <td class="text-center"><select
                                                                                className="form-control form-control-sm w-100"
                                                                                id="roledb"
                                                                                style={{ textAlign: "left" }}
                                                                                value={item.HallCheckliststatusID}
                                                                                // disabled={isView || isReadOnly}
                                                                                onChange={(e) => this.changeTable(0, item.DailyRoutineHallChecklistMappingID, e.target.value)}
                                                                            >
                                                                                <option value="">Select</option>
                                                                                {statusList.length > 0 && statusList.map((data) => (
                                                                                    <option key={data.HallCheckliststatusID} value={data.HallCheckliststatusID}>{data.Name}</option>
                                                                                ))}
                                                                            </select>
                                                                            </td>
                                                                            {/* Remark box: resizable up and down only, and capped so one row can't grow taller than the table */}
                                                                            <td><textarea class="form-control" value={item.Remark} onChange={(e) => this.changeTable(1, item.DailyRoutineHallChecklistMappingID, e.target.value)} rows="2" style={{ resize: "vertical", minHeight: 60, maxHeight: 150 }}></textarea></td>
                                                                        </tr>
                                                                    ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>}
                                                        {(isView || fromChecklist) && <div class="row m-0 mt-2 p-0">
                                                            <div class="d-flex justify-content-between align-items-center mb-2 p-0">
                                                                <span class="fw-bold"> {
                                                                    <span className="text-danger fw-normal text-start text-left d-block mt-1">
                                                                        {DRCListErr}
                                                                    </span>
                                                                }</span>

                                                                <button onClick={() => this.addMainTask()} disabled={!this.getWriteAccess()} class="btn btn-aqua btn-sm" >Add Task</button>
                                                            </div>

                                                            <div className="table-responsive sticky-table-wrapper w-100 p-0" style={{ maxHeight: "calc(100vh - 320px)", overflowY: "auto" }}>
                                                                <table class="table table-bordered sticky-table mb-0" id="checklistTable">
                                                                    {/* zIndex above the body cells (custom.css gives .sticky-table td z-index 1), so rows scroll under the header */}
                                                                <thead class="table-light" style={{ position: "sticky", top: 0, zIndex: 21 }}>
                                                                        <tr>
                                                                            <th className="text-center" style={{ width: '60px' }}>Sr. No.</th>
                                                                            <th>Checklist Description<span className="text-red">*</span></th>
                                                                            <th>Additional Instruction</th>
                                                                            <th style={{ width: '200px' }}>Service Partner<span className="text-red">*</span></th>
                                                                            <th style={{ width: '130px' }}>Start Time<span className="text-red">*</span></th>
                                                                            <th style={{ width: '120px' }}>End Time<span className="text-red">*</span></th>
                                                                            <th style={{ width: '175px' }}>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {DRCList.length > 0 && DRCList.map((item, i) => (
                                                                            <tr data-row="1">
                                                                                <td className="sr-no text-center align-middle">{item.srno}</td>
                                                                                <td><textarea class="form-control" rows="2" value={item.desc} disabled={!this.getUpdateAccess()} onChange={(e) => this.editChecklist(e.target.value, i, 0)}></textarea></td>
                                                                                <td><textarea class="form-control" rows="2" value={item.addInt} disabled={!this.getUpdateAccess()} onChange={(e) => this.editChecklist(e.target.value, i, 1)}></textarea></td>
                                                                                <td><select
                                                                                    className="form-control form-control-sm w-100"
                                                                                    id="roledb"
                                                                                    style={{ textAlign: "left" }}
                                                                                    value={item.AccountID}
                                                                                    disabled={!this.getUpdateAccess()}
                                                                                    // disabled={isView || isReadOnly}
                                                                                    onChange={(e) => this.editChecklist(e.target.value, i, 4)}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {vendorList.length > 0 && vendorList.map((data) => (
                                                                                        <option key={data.AccountID} value={data.AccountID}>{data.CompanyName}</option>
                                                                                    ))}
                                                                                </select></td>
                                                                                <td>
                                                                                    <TimePicker
                                                                                        className="form-control"
                                                                                        style={{ width: "100%", height: "38px" }}
                                                                                        disabled={!this.getUpdateAccess()}
                                                                                        value={item.startTime ? dayjs(item.startTime, 'HH:mm') : null}
                                                                                        format="HH:mm"
                                                                                        open={this.state.openPicker === `start_${i}`}
                                                                                        onOpenChange={(open) => {
                                                                                            this.setState({
                                                                                                openPicker: open ? `start_${i}` : null,
                                                                                                pendingTime: {
                                                                                                    ...this.state.pendingTime,
                                                                                                    [`start_${i}`]: item.startTime ? {
                                                                                                        hour: parseInt(item.startTime.split(':')[0], 10),
                                                                                                        minute: parseInt(item.startTime.split(':')[1], 10)
                                                                                                    } : null
                                                                                                }
                                                                                            });
                                                                                        }}
                                                                                        onSelect={(time) => this.onTimePickerSelect(time, `start_${i}`, i, 2)}
                                                                                        onChange={(time, timeString) => this.onTimePickerChange(time, timeString, i, 2, `start_${i}`)}
                                                                                        needConfirm={false}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <TimePicker
                                                                                        className="form-control"
                                                                                        style={{ width: "100%", height: "38px" }}
                                                                                        disabled={!this.getUpdateAccess()}
                                                                                        value={item.endTime ? dayjs(item.endTime, 'HH:mm') : null}
                                                                                        format="HH:mm"
                                                                                        open={this.state.openPicker === `end_${i}`}
                                                                                        onOpenChange={(open) => {
                                                                                            this.setState({
                                                                                                openPicker: open ? `end_${i}` : null,
                                                                                                pendingTime: {
                                                                                                    ...this.state.pendingTime,
                                                                                                    [`end_${i}`]: item.endTime ? {
                                                                                                        hour: parseInt(item.endTime.split(':')[0], 10),
                                                                                                        minute: parseInt(item.endTime.split(':')[1], 10)
                                                                                                    } : null
                                                                                                }
                                                                                            });
                                                                                        }}
                                                                                        onSelect={(time) => this.onTimePickerSelect(time, `end_${i}`, i, 3)}
                                                                                        onChange={(time, timeString) => this.onTimePickerChange(time, timeString, i, 3, `end_${i}`)}
                                                                                        needConfirm={false}
                                                                                    />
                                                                                </td>
                                                                                <td className="text-nowrap align-middle">
                                                                                    {item.parentId == null && <button disabled={!this.getUpdateAccess()} class="btn btn-aqua btn-sm add-child me-2" onClick={() => this.addSubTask(item.srno)}>Add Sub Task</button>}
                                                                                    {item.parentId != null ? <button disabled={!this.getDeleteAccess()} class="btn btn-aqua-border" onClick={() => this.onDeleteChecklist(i, item.parentId == null ? 0 : 1)}>Delete</button> : totalParents > 1 ? <button class="btn btn-aqua-border" disabled={!this.getDeleteAccess()} onClick={() => this.onDeleteChecklist(i, item.parentId == null ? 0 : 1)}>Delete</button> : <></>}
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>}

                                                        {(isView || fromChecklist) && <div class="row m-0 mt-2 p-0">
                                                            <div class="d-flex justify-content-between align-items-center mb-2 p-0">
                                                                <h6 class="fw-semibold">Sugguestions List {
                                                                    <span className="text-danger fw-normal text-start text-left d-block mt-1">
                                                                        {/* {DRCListErr} */}
                                                                    </span>
                                                                }</h6>

                                                                {/* <button onClick={() => this.addMainTask()} class="btn btn-aqua btn-sm" >Add Task</button> */}
                                                            </div>

                                                            <div className="table-responsive sticky-table-wrapper w-100 p-0 suggestions-table-wrapper" style={{ maxHeight: "250px", overflow: "auto" }}>
                                                                <table class="table table-bordered mb-0" id="checklistTable">
                                                                    <thead class="table-light">
                                                                        <tr>
                                                                            <th className="text-center" style={{ width: '50px' }}>Sr. No.</th>
                                                                            <th className="text-center" >Checklist Date</th>
                                                                            <th className="text-center" >From Time </th>
                                                                            <th className="text-center" >To Time</th>
                                                                            <th className="text-center" >Location</th>
                                                                            <th className="text-center" style={{ width: '70px' }}>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {sugguestionsList.length > 0 && sugguestionsList.map((item, i) => (
                                                                            <tr data-row="1">
                                                                                <td className="text-center">{i + 1}</td>
                                                                                <td className="text-center">{moment(item.ChecklistDate).format('DD/MM/YYYY')}</td>
                                                                                <td className="text-center">{item.FromTime}</td>
                                                                                <td className="text-center">{item.ToTime}</td>
                                                                                <td className="text-center">{item.HallName}</td>
                                                                                {/* <td>
                                                                                    <input class="form-check-input" type="checkbox" checked={item.isSelect} value={item.tempId} onClick={() => this.onChecktSuggestions(item.tempId)} />
                                                                                </td> */}
                                                                                <td className="text-center">
                                                                                    <input
                                                                                        disabled={!this.getUpdateAccess()}
                                                                                        type="checkbox"
                                                                                        checked={item.isSelect} value={item.tempId} onClick={() => this.onChecktSuggestions(item.tempId)}
                                                                                    />
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>}
                                                        <div class="mt-2 text-end p-0">
                                                            <button disabled={!this.getUpdateAccess()} type="button" class="btn btn-aqua mx-2" onClick={() => (isView || fromChecklist) ? this.insertUpdateDRC() : this.insertUpdateDRT()}>Save</button>
                                                            <button type="button" class="btn btn-gray" onClick={() => this.leavePage(false)}>{this.props.embedded ? 'Close' : 'Back'}</button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </section>
                            </div>
                        </main>

                    </div>
                </>
            </>)
    }
}


export default withRouter(connect(null, {
    fill_action, getDRTSuggestions_action, getDRCDetails_action, updateDRTChecklist_action,
    getDRTDetails_action, updateDRT_action    //  delateDRC_action
})(DailyRoutineTaskUpdate));